import siteConfig from "@iso/config/site.config";
import {
  getGetRequestInfo,
  getDeleteRequestInfo,
  getPutRequestInfo,
  getPostRequestInfo,
  getRequestGeneratorFunction
} from "@iso/utils/connectUtils";
import { put } from "redux-saga/effects";
import circuitUrls from "src/infinode/constants/urls/circuitUrls";
import actions from "./actions";

const { getCircuitsListUrl, getCircuitUrl, getCircuitCategoriesUrl, getCircuitDemandUrl } = circuitUrls;

const onGetCircuitCategoryRequest = () =>
  fetch(`${siteConfig.apiUrl}${getCircuitCategoriesUrl()}`, getGetRequestInfo()).then(response => response);

const onGetCircuitCategorySuccess = function* (resultBody, params) {
  if (resultBody !== undefined) {
    yield put({
      type: actions.GET_CIRCUIT_CATEGORIES_SUCCESS,
      categories: resultBody
    });
    return true;
  }
  return false;
};

const getCircuitCategoriesRequest = getRequestGeneratorFunction(
  actions.GET_CIRCUIT_CATEGORIES_REQUEST,
  actions.CIRCUITS_ERROR,
  onGetCircuitCategoryRequest,
  onGetCircuitCategorySuccess
);

const onGetCircuitsListRequest = ({ token, siteId, zoneId }) =>
  fetch(`${siteConfig.apiUrl}${getCircuitsListUrl(siteId, zoneId)}`, getGetRequestInfo(token)).then(
    response => response
  );

const onGetCircuitsListSuccess = function* (resultBody, params) {
  if (resultBody.circuits !== undefined) {
    yield put({
      type: actions.GET_CIRCUITS_SUCCESS,
      circuits: resultBody.circuits,
      siteId: params.siteId,
      zoneId: params.zoneId
    });
    return true;
  }
  return false;
};

const getCircuitsListRequest = getRequestGeneratorFunction(
  actions.GET_CIRCUITS_REQUEST,
  actions.CIRCUITS_ERROR,
  onGetCircuitsListRequest,
  onGetCircuitsListSuccess
);

const onGetCircuitRequest = ({ token, id, siteId, zoneId }) =>
  fetch(`${siteConfig.apiUrl}${getCircuitUrl(siteId, zoneId)}/${id}`, getGetRequestInfo(token)).then(
    response => response
  );

const onGetCircuitSuccess = function* (resultBody, params) {
  if (resultBody.circuit) {
    yield put({
      type: actions.GET_CIRCUIT_SUCCESS,
      circuit: resultBody.circuit,
      siteId: params.siteId,
      zoneId: params.zoneId
    });
    return true;
  }
  return false;
};

const getCircuitRequest = getRequestGeneratorFunction(
  actions.GET_CIRCUIT_REQUEST,
  actions.CIRCUITS_ERROR,
  onGetCircuitRequest,
  onGetCircuitSuccess
);

const onDeleteCircuitRequest = ({ token, id, siteId, zoneId }) =>
  fetch(`${siteConfig.apiUrl}${getCircuitUrl(siteId, zoneId)}/${id}`, getDeleteRequestInfo(token)).then(
    response => response
  );

const onDeleteCircuitSuccess = function* (resultBody, params) {
  yield console.log(resultBody);
  if (resultBody === true) {
    yield put({
      type: actions.DELETE_CIRCUIT_SUCCESS,
      id: params.id,
      siteId: params.siteId,
      zoneId: params.zoneId
    });
    return true;
  }
  return false;
};

const deleteCircuitRequest = getRequestGeneratorFunction(
  actions.DELETE_CIRCUIT_REQUEST,
  actions.CIRCUITS_ERROR,
  onDeleteCircuitRequest,
  onDeleteCircuitSuccess
);

const onUpdateCircuitRequest = ({ token, circuit, siteId, zoneId }) =>
  fetch(`${siteConfig.apiUrl}${getCircuitUrl(siteId, zoneId)}/${circuit.id}`, getPutRequestInfo(circuit, token)).then(
    response => response
  );

const onUpdateCircuitSuccess = function* (resultBody, params) {
  if (resultBody.circuit) {
    yield put({
      type: actions.UPDATE_CIRCUIT_SUCCESS,
      circuit: resultBody.circuit,
      siteId: params.siteId,
      zoneId: params.zoneId
    });
    return true;
  }
  return false;
};

const updateCircuitRequest = getRequestGeneratorFunction(
  actions.UPDATE_CIRCUIT_REQUEST,
  actions.CIRCUITS_ERROR,
  onUpdateCircuitRequest,
  onUpdateCircuitSuccess
);

const onCreateCircuitRequest = ({ token, circuit, siteId, zoneId }) =>
  fetch(`${siteConfig.apiUrl}${getCircuitUrl(siteId, zoneId)}`, getPostRequestInfo(circuit, token)).then(
    response => response
  );

const onCreateCircuitSuccess = function* (resultBody, params) {
  if (resultBody.circuit) {
    yield put({
      type: actions.CREATE_CIRCUIT_SUCCESS,
      circuit: resultBody.circuit,
      siteId: params.siteId,
      zoneId: params.zoneId
    });
    return true;
  }
  return false;
};

const createCircuitRequest = getRequestGeneratorFunction(
  actions.CREATE_CIRCUIT_REQUEST,
  actions.CIRCUITS_ERROR,
  onCreateCircuitRequest,
  onCreateCircuitSuccess
);

const onUpdateCircuitDemandConfigRequest = ({ token, siteId, zoneId, circuitId, demandSwitch, demandType, interval }) =>
  fetch(
    `${siteConfig.apiUrl}${getCircuitDemandUrl(siteId, zoneId, circuitId)}`,
    getPutRequestInfo({ siteId, zoneId, circuitId, demandSwitch, demandType, interval }, token)
  ).then(response => response);

const onUpdateCircuitDemandConfigSuccess = function* (
  resultBody,
  { siteId, zoneId, circuitId, demandSwitch, demandType, interval }
) {
  if (resultBody) {
    yield put({
      type: actions.UPDATE_CIRCUIT_DEMAND_CONFIG_SUCCESS,
      siteId,
      zoneId,
      circuitId,
      demandSwitch,
      demandType,
      interval
    });
    return true;
  }
  return false;
};

const updateCircuitDemandConfigRequest = getRequestGeneratorFunction(
  actions.UPDATE_CIRCUIT_DEMAND_CONFIG_REQUEST,
  actions.CIRCUITS_ERROR,
  onUpdateCircuitDemandConfigRequest,
  onUpdateCircuitDemandConfigSuccess
);

export default {
  getCircuitCategoriesRequest,
  getCircuitsListRequest,
  getCircuitRequest,
  deleteCircuitRequest,
  updateCircuitRequest,
  createCircuitRequest,
  updateCircuitDemandConfigRequest
};
